import { BaseJourneyDataset, Journey } from 'ev-types';

export type FrontDoorStatus = 'active' | 'inactive' | 'draft';

export enum FrontDoorAssignment {
  FirstAvailable = 'first_available',
  Group = 'group',
  Provider = 'provider',
}

export enum FrontDoorStepType {
  Doorway = 'front_door_doorway',
  VisitExperience = 'front_door_visit_experience',
  ClosedScreen = 'closed_screen',
}

export type VisitExperienceDataset = {
  visit_type_id?: number;
};

export type FrontDoorShortUrl = {
  id: number;
  full_link: string;
  slug: string;
  pre_slug: string;
  short_links: {
    [key: string]: string;
  };
};

export type FrontDoor = {
  id: number;
  name: string;
  status: FrontDoorStatus;
  owner_id: number;
  front_door_type: 'standard';
  journey_id: number;
  journey?: Journey;
  shortened_urls?: FrontDoorShortUrl[];
};

export type FrontDoorDataset = BaseJourneyDataset & {
  url?: string;
  practice_id?: number;
  practice_handle?: string;
  locale?: string;
};
